webpackJsonp([28,93,94,188,189,258,259],{

/***/ 1192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isSwitched: false,
            isSwitchedCustom: 'Yes'
        };
    }
});

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-switch', [_vm._v("Default")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isSwitched),
      callback: function($$v) {
        _vm.isSwitched = $$v
      },
      expression: "isSwitched"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSwitched) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "true-value": "Yes",
      "false-value": "No"
    },
    model: {
      value: (_vm.isSwitchedCustom),
      callback: function($$v) {
        _vm.isSwitchedCustom = $$v
      },
      expression: "isSwitchedCustom"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSwitchedCustom) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n                Default\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "value": true,
      "type": "is-info"
    }
  }, [_vm._v("\n                Info\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "value": true,
      "type": "is-success"
    }
  }, [_vm._v("\n                Success\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "value": true,
      "type": "is-danger"
    }
  }, [_vm._v("\n                Danger\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "value": true,
      "type": "is-warning"
    }
  }, [_vm._v("\n                Warning\n            ")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "size": "is-small"
    }
  }, [_vm._v("Small")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', [_vm._v("Default")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "size": "is-medium"
    }
  }, [_vm._v("Medium")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-switch', {
    attrs: {
      "size": "is-large"
    }
  }, [_vm._v("Large")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            size: '',
            type: null,
            isRounded: false,
            isOutlined: false
        };
    }
});

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.isRounded),
      callback: function($$v) {
        _vm.isRounded = $$v
      },
      expression: "isRounded"
    }
  }, [_vm._v("Rounded")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.isOutlined),
      callback: function($$v) {
        _vm.isOutlined = $$v
      },
      expression: "isOutlined"
    }
  }, [_vm._v("Outlined")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Type"
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("Danger")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1)], 1), _vm._v(" "), _c('b-switch', {
    attrs: {
      "rounded": _vm.isRounded,
      "outlined": _vm.isOutlined,
      "size": _vm.size,
      "type": _vm.type
    }
  }, [_vm._v("Sample")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_switch__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_switch__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExStyles__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExStyles__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExStyles__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_switch__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_switch__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExTypes: __WEBPACK_IMPORTED_MODULE_4__examples_ExTypes___default.a,
            ExSizes: __WEBPACK_IMPORTED_MODULE_6__examples_ExSizes___default.a,
            ExStyles: __WEBPACK_IMPORTED_MODULE_8__examples_ExStyles___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExTypesCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExTypes___default.a,
            ExSizesCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExSizes___default.a,
            ExStylesCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExStyles___default.a
        };
    }
});

/***/ }),

/***/ 1506:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-switch>Default</b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch v-model=\"isSwitched\">\n                {{ isSwitched }}\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch v-model=\"isSwitchedCustom\"\n                true-value=\"Yes\"\n                false-value=\"No\">\n                {{ isSwitchedCustom }}\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch disabled>Disabled</b-switch>\n        </div>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isSwitched: false,\n                isSwitchedCustom: 'Yes'\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1507:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-switch :value=\"true\">\n                Default\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch :value=\"true\"\n            type=\"is-info\">\n                Info\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch :value=\"true\"\n            type=\"is-success\">\n                Success\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch :value=\"true\"\n            type=\"is-danger\">\n                Danger\n            </b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch :value=\"true\"\n            type=\"is-warning\">\n                Warning\n            </b-switch>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1508:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"field\">\n            <b-switch size=\"is-small\">Small</b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch>Default</b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch size=\"is-medium\">Medium</b-switch>\n        </div>\n        <div class=\"field\">\n            <b-switch size=\"is-large\">Large</b-switch>\n        </div>\n    </section>\n</template>\n"

/***/ }),

/***/ 1509:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped>\n            <b-switch v-model=\"isRounded\">Rounded</b-switch>\n            <b-switch v-model=\"isOutlined\">Outlined</b-switch>\n        </b-field>\n        <b-field grouped>\n            <b-field label=\"Type\">\n                <b-select v-model=\"type\" placeholder=\"Type\">\n                    <option value=\"null\">Default</option>\n                    <option value=\"is-primary\">Primary</option>\n                    <option value=\"is-success\">Success</option>\n                    <option value=\"is-warning\">Warning</option>\n                    <option value=\"is-danger\">Danger</option>\n                </b-select>\n            </b-field>\n            <b-field label=\"Size\">\n                <b-select v-model=\"size\">\n                    <option value=\"\">Default</option>\n                    <option value=\"is-small\">is-small</option>\n                    <option value=\"is-medium\">is-medium</option>\n                    <option value=\"is-large\">is-large</option>\n                </b-select>\n            </b-field>\n        </b-field>\n        <b-switch\n            :rounded=\"isRounded\"\n            :outlined=\"isOutlined\"\n            :size=\"size\"\n            :type=\"type\">Sample</b-switch>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                size: '',\n                type: null,\n                isRounded: false,\n                isOutlined: false,\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypes,
      "code": _vm.ExTypesCode,
      "title": "Types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExStyles,
      "code": _vm.ExStylesCode,
      "title": "Styles",
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>type</code>',
        description: 'Type (color) of the switch, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '—'
    }, {
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Any',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>native-value</code>',
        description: 'Same as native <code>value</code>',
        type: 'Any',
        values: '—',
        default: '—'
    }, {
        name: '<code>true-value</code>',
        description: 'Overrides the returned value when it\'s checked',
        type: 'Any',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>false-value</code>',
        description: 'Overrides the returned value when it\'s not checked',
        type: 'Any',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Same as native <code>disabled</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>name</code>',
        description: 'Same as native <code>name</code>',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>size</code>',
        description: 'Size  of the control, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>rounded</code>',
        description: 'Rounded style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>outlined</code>',
        description: 'Outlined style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }],
    events: [{
        name: '<code>input</code>',
        description: 'Triggers when the value of the switch is changed',
        parameters: '<code>value: Boolean</code>'
    }, {
        name: '<code>[any].native</code>',
        description: 'Listen to any event using this syntax, e.g <code>click.native</code>',
        parameters: '<code>event: $event</code>'
    }]
}]);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$switch-width-number</code>',
    default: '<code>2.75</code>'
}, {
    name: '<code>$switch-width</code>',
    default: '<code>$switch-width-number * 1em</code>'
}, {
    name: '<code>$switch-padding</code>',
    default: '<code>0.2em</code>'
}, {
    name: '<code>$switch-active-background-color</code>',
    default: '<code>$primary</code>'
}]);

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1192),
  /* template */
  __webpack_require__(1193),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1194),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1196),
  /* template */
  __webpack_require__(1197),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1505),
  /* template */
  __webpack_require__(1510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/28.391dfa7dff221a8514cd.js